import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { UI } from "../components/ActionDrawer";
import DashTable, { PageHead } from "../components/DashTable";
import PageLoader from "../components/Loader";
import { useToast } from "../components/Toast";
import apiService from "../Services/api.service";

const inr = (n) =>
  n === null || n === undefined || n === ""
    ? "—"
    : `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

/* Sales Lead's team view. Read-only. */
const Specialists = () => {
  const toast = useToast();
  const token = localStorage.getItem("token");

  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadFailed, setLoadFailed] = useState(false);

  const fetchRows = async () => {
    setIsLoading(true);
    setLoadFailed(false);
    try {
      const res = await apiService.fetchSpecialists(token);
      setRows(res.data || []);
      setSummary(res.summary || null);
    } catch (error) {
      setLoadFailed(true);
      toast.error("Error while fetching specialists");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { label: "Name" },
    { label: "Role" },
    { label: "Live orders", num: true },
    { label: "Pipeline value", num: true },
    { label: "Won last 30d", num: true },
    { label: "Avg cycle" },
    { label: "Stalled", num: true },
  ];

  const tableRows = rows.map((row) => ({
    key: row.id,
    cells: [
      <Box component="span" sx={{ fontWeight: 500 }}>
        {row.name}
      </Box>,
      row.role,
      row.liveOrders ?? 0,
      inr(row.pipelineValue),
      row.won30d ?? 0,
      row.avgCycleDays ? `${row.avgCycleDays} days` : "—",
      row.stalled ? (
        <Box component="span" sx={{ color: UI.red, fontWeight: 500 }}>
          {row.stalled}
        </Box>
      ) : (
        0
      ),
    ],
  }));

  const kpis = summary
    ? [
        { label: "Specialists", value: summary.specialists ?? rows.length },
        { label: "Live orders", value: summary.liveOrders },
        { label: "Pipeline value", value: inr(summary.pipelineValue) },
        { label: "Stalled", value: summary.stalled, alarm: true },
      ]
    : [];

  return (
    <Box sx={{ padding: { xs: "18px 16px 50px", md: "24px 28px 60px" }, maxWidth: 1240 }}>
      <PageHead
        title="Specialists"
        lede="Performance across your team. Read-only."
        kpis={kpis}
      />

      <DashTable
        columns={columns}
        rows={tableRows}
        emptyText="No specialists yet."
        errorText={loadFailed ? "Could not load specialists." : null}
        onRetry={fetchRows}
        foot={
          summary
            ? `${summary.liveOrders ?? 0} live orders across ${
                summary.specialists ?? rows.length
              } specialists`
            : null
        }
      />

      {isLoading && <PageLoader />}
    </Box>
  );
};

export default Specialists;
